{
  "background": {
    "background-default": "hsl(210, 28.571429%, 2.745098%)",
    "background-subtle": "hsl(204, 15.151515%, 6.470588%)"
  },
  "surface": {
    "surface-default": "hsl(204, 15.151515%, 6.470588%)",
    "surface-raised": "hsl(206.666667, 11.688312%, 15.098039%)",
    "surface-sunken": "hsl(210, 28.571429%, 2.745098%)"
  },
  "text": {
    "text-default": "hsl(0, 0%, 96.078431%)",
    "text-muted": "hsl(200, 9.89011%, 82.156863%)",
    "text-subtle": "hsl(198, 4.385965%, 55.294118%)",
    "text-inverse": "hsl(210, 28.571429%, 2.745098%)",
    "text-link": "hsl(196.173913, 100%, 77.45098%)"
  },
  "border": {
    "border-default": "hsl(204, 8.62069%, 22.745098%)",
    "border-subtle": "hsl(206.666667, 11.688312%, 15.098039%)",
    "border-strong": "hsl(198, 4.385965%, 55.294118%)"
  },
  "action": {
    "action-default": "hsl(202.396313, 100%, 57.45098%)",
    "action-hover": "hsl(196.173913, 100%, 77.45098%)",
    "action-subtle": "hsl(222.545455, 100%, 10.784314%)"
  },
  "success": {
    "success-surface": "hsl(120, 100%, 4.313725%)",
    "success-text": "hsl(115.081967, 35.260116%, 66.078431%)",
    "success-border": "hsl(121.333333, 100%, 17.647059%)",
    "success-solid": "hsl(118.181818, 47.826087%, 40.588235%)"
  },
  "warning": {
    "warning-surface": "hsl(6.153846, 100%, 7.647059%)",
    "warning-text": "hsl(18, 74.626866%, 73.72549%)",
    "warning-border": "hsl(19.849624, 95.683453%, 27.254902%)",
    "warning-solid": "hsl(19.245283, 64.37247%, 51.568627%)"
  },
  "danger": {
    "danger-surface": "hsl(356.571429, 100%, 6.862745%)",
    "danger-text": "hsl(358.636364, 67.692308%, 74.509804%)",
    "danger-border": "hsl(347.288136, 90.769231%, 25.490196%)",
    "danger-solid": "hsl(353.333333, 54.216867%, 51.176471%)"
  },
  "info": {
    "info-surface": "hsl(228.461538, 86.666667%, 5.882353%)",
    "info-text": "hsl(218.181818, 35.106383%, 63.137255%)",
    "info-border": "hsl(219.74026, 60.629921%, 24.901961%)",
    "info-solid": "hsl(219.183673, 42.608696%, 45.098039%)"
  }
}
